import {useTranslation} from "react-i18next";
import { AFFILIATE_STATUS_DISMISSED, AFFILIATE_STATUS_READY } from "./Constants";

export const useStatusValuesAffiliate = () => {
    const {t} = useTranslation(['salesmarketing']);

    const getStatusLabelAffiliate = (status: string) => {
        switch (status) {
            case AFFILIATE_STATUS_READY: return t('salesmarketing:affiliate.statusValues.ready');
            case AFFILIATE_STATUS_DISMISSED: return t('salesmarketing:affiliate.statusValues.dismissed');
            default: return ""; 
        }
    };

    return {
        getStatusLabelAffiliate
    }
}